import React, { useState, FormEvent, useEffect } from 'react';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import './style/login.css'; // External stylesheet
import { forgotPassword } from '../../actions/UserManagement';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState<string>('');
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      const response = await forgotPassword(email);
      setSuccessMessage('Password reset link sent successfully.');
      setErrorMessage(null);

    } catch (error) {
      setSuccessMessage(null);
      setErrorMessage('Failed to send reset link. Please try again.');
      console.error(error);
    }
  };

  useEffect(() => {
    document.title = 'Forgot Password | Vinimark | The Wine Company';
  })

  return (
      <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          width: '100%',
          // overflow: 'hidden'
      }}>

      <Header />
      <div className="forgot-password-container">
  <div className="forgot-password-inner">
          <div className="site-grid" style={{ width: '100%' }}>
            <div className="item item-double-content">
              <div className="item-inner"></div>
              <div className="item-inner item-inner-content">
                <div className="content">
                  <div className="content-title">
                    <h2 className="content-title-small">Forgot Password</h2>
                  </div>
                  <div className="content-text">
                    <p className='content-text'>Send a link to reset your password.</p>
                  </div>

                  <form className="content-form" onSubmit={handleSubmit}>
                  {successMessage && <p className="success-message">{successMessage}</p>}
                  {errorMessage && <p className="error-message">{errorMessage}</p>}
                  <div className="content-form-field">
                      <input
                        type="text"
                        className="input-email"
                        placeholder="Email Address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>

                    <div className="content-form-button">
                      <button type="submit" className="button button-wide">Send Password Link</button>
                    </div>

                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ForgotPassword;
